import './ActualPrStats.styles.scss';

import { FC } from 'react';

import { ActualPrStatsProps } from './ActualPrStats.types';

const ActualPrStats: FC<ActualPrStatsProps> = ({ actualPrStats }) => (
  <div className="ActualPrStats-Component">
    <b>ACTUAL PRSTATS</b>
    <div className="actual-prstats-info">
      <p>VPIP: {actualPrStats?.vpip ?? '–'}</p>
      <p>PFR: {actualPrStats?.pfr ?? '–'}</p>
    </div>
  </div>
);

export default ActualPrStats;
